import { format } from 'date-fns';

export function getLocalDateWithOffset(date: Date | string) {
  const initialDate = new Date(date);

  return format(initialDate, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
}
